import { useRef } from "react";
import {
  motion,
  useScroll,
  useVelocity,
  useSpring,
  useTransform,
  useMotionValue,
  useAnimationFrame,
} from "framer-motion";

const wrap = (min, max, v) => {
  const range = max - min;
  return ((((v - min) % range) + range) % range) + min;
};

const Row = ({ text, baseVelocity, className }) => {
  const baseX = useMotionValue(0);
  const { scrollY } = useScroll();
  const scrollVelocity = useVelocity(scrollY);
  const smooth = useSpring(scrollVelocity, { damping: 50, stiffness: 400 });
  const velocityFactor = useTransform(smooth, [0, 1000], [0, 4], { clamp: false });
  const x = useTransform(baseX, (v) => `${wrap(-25, -50, v)}%`);
  const dir = useRef(1);

  useAnimationFrame((t, delta) => {
    let moveBy = dir.current * baseVelocity * (delta / 1000);
    if (velocityFactor.get() < 0) dir.current = -1;
    else if (velocityFactor.get() > 0) dir.current = 1;
    moveBy += dir.current * moveBy * velocityFactor.get();
    baseX.set(baseX.get() + moveBy);
  });

  return (
    <div className="flex flex-nowrap overflow-hidden whitespace-nowrap">
      <motion.div className="flex flex-nowrap whitespace-nowrap" style={{ x }}>
        {Array.from({ length: 4 }).map((_, i) => (
          <span key={i} className={`block mr-10 ${className}`}>
            {text}
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export const VelocityMarquee = () => (
  <section className="relative overflow-hidden py-12 md:py-20" data-testid="big-statement-section">
    <Row
      text="TURN COMPLEXITY INTO CLARITY —"
      baseVelocity={2.2}
      className="font-display font-black uppercase leading-none tracking-tighter text-[13vw] md:text-[9vw] text-transparent [-webkit-text-stroke:1px_rgba(10,27,69,0.18)]"
    />
    <Row
      text="TURN IDEAS INTO IMPACT —"
      baseVelocity={-2.2}
      className="font-display font-black uppercase leading-none tracking-tighter text-[13vw] md:text-[9vw] gradient-text-animated"
    />
  </section>
);
